import { percentFormatCompact } from '@/utils/hooks/format/useFormatNumber';

import { mediaLifeSpanConfig } from '@/lib/analytics/charts/instagram/mediaLifeSpan';

import { BarGroupedChartComponent } from '@/components/composite/Charts/BarGroupedChart';

export const mediaLifeSpanMVConfig = {
    ...mediaLifeSpanConfig,
    id: 'media_life_span_media_viewer',
    margin: { left: -40, bottom: 15 },
    minWidth: 0,
    title: 'chart.instagram.media_life_span_media_viewer_likes_thirty_minutes',
    subtitle: 'chart.instagram.media_life_span_media_viewer_likes_thirty_minutes_subtitle',
    icon: 'likes',
    data_format: percentFormatCompact,
    yAxisAllowDecimal: false,
    name: {
        time: 'time',
        value: 'current_post'
    },
    color: {
        value: 'red'
    },
    type: 'chart',
    tooltipTranslation: {
        token: 'chart.instagram.media_life_span_media_viewer_tooltip_chart',
        values: ['time', 'value']
    },
    element: BarGroupedChartComponent
};
